/**
 * SpecialOrder — Mijoz buyurtmasi (do'konda yo'q mahsulot) sxemalari.
 *
 * Mijoz kelib, do'konda mavjud bo'lmagan mahsulotni buyurtma qiladi. Sotuvchi
 * mijozni (mavjud yoki yangi) + mahsulot nomi + RASM (kamera/fayl) + taminotchi
 * ("kimda bor") kiritadi → Telegram'ga avtomatik xabar boradi. Bir buyurtma =
 * bitta mahsulot. Holat oqimi: PENDING → ORDERED → ARRIVED → COMPLETED (yoki CANCELLED).
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
export const SPECIAL_ORDER_STATUSES = [
    'PENDING', // yangi — taminotchiga berilmagan
    'ORDERED', // taminotchiga buyurtma berildi
    'ARRIVED', // keldi (mijozga xabar beriladi)
    'COMPLETED', // mijoz olib ketdi
    'CANCELLED', // bekor qilindi
];
// ─── Create (sotuvchi yaratadi) ───────────────────────────────────
export const createSpecialOrderSchema = z.object({
    // Mijoz — mavjud bo'lsa ID, walk-in bo'lsa faqat nom/telefon
    customerId: uuidSchema.nullable().optional(),
    customerName: z.string().trim().min(1, 'Mijoz ismi kerak').max(150),
    customerPhone: z.string().trim().max(30).nullable().optional(),
    // Buyurtma qilingan mahsulot (katalogda yo'q)
    productName: z.string().trim().min(1, 'Mahsulot nomi kerak').max(300),
    image: z.string().trim().max(500).nullable().optional(),
    quantity: z.number().int().min(1, 'Soni 1 dan kam emas').max(100_000).default(1),
    // Kimda bor — taminotchi
    supplierId: uuidSchema.nullable().optional(),
    supplierName: z.string().trim().max(150).nullable().optional(),
    note: z.string().trim().max(500).nullable().optional(),
    // Kutilayotgan vaqt (sana + soat) — ISO 8601. "1 kun oldin" eslatma shunга bog'lanadi.
    expectedAt: z.string().datetime({ offset: true }).nullable().optional(),
});
// ─── Status yangilash ─────────────────────────────────────────────
export const updateSpecialOrderStatusSchema = z.object({
    status: z.enum(SPECIAL_ORDER_STATUSES),
});
// ─── Ro'yxat filtri ───────────────────────────────────────────────
export const specialOrderQuerySchema = z.object({
    status: z.enum(SPECIAL_ORDER_STATUSES).optional(),
    supplierId: uuidSchema.optional(),
});
//# sourceMappingURL=special-order.schema.js.map